// eslint-disable-next-line no-unused-vars
import Vue from 'vue';
import { globalBus } from './globalBus';
import md5 from 'js-md5';
export default {
    install(Vue) {
        // 路由跳转
        Vue.prototype.$goToUrl = function (url) {
            this.$router.push(url);
        }
        // 计算高度
        Vue.prototype.$gdjz= function (div, offset, callback) {
            let dom = this.$refs[div] // 等同于document.querySelector('.earth') true
            if(dom){
                var a,b,c,d;
                d = dom.offsetTop // 元素距离相对父级的高度，这里父级指的是body
                a = eval(d + offset)
                b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //  获取窗口滚动条高度
                c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
                if( b + c > a ) {
                    callback && callback(1)
                }else{
                    callback && callback(2)
                }
            }
        }
        // 跳转用户客户端下载
        Vue.prototype.$goToUserClient = function () {
            window.open('https://cdnoss.365paotui.cn/help/app/common/downApp/downOrderApp.html');
        }
        // 跳转骑士端下载
        Vue.prototype.$goToDriverClient = function () {
            window.open('https://cdnoss.365paotui.cn/help/app/common/downApp/downPartTimeApp.html');
        }
        ///======================= 日志管理 ============================================
        //日期格式
        Vue.prototype.$dateTimeFormat = "YYYY-MM-DD HH:mm:ss";
        Vue.prototype.$commonDateTimeFormat = "YYYY-MM-DD HH:mm";
        Vue.prototype.$dateDay00Format = "YYYY-MM-DD 00:00:00";
        Vue.prototype.$dateDay24Format = "YYYY-MM-DD 24:00:00";
        Vue.prototype.$planShipDateDayFormat = "YYYYMMDDHHmm";
        Vue.prototype.$dateYearFormat = "YYYY";
        Vue.prototype.$dateMonthFormat = "YYYY-MM";
        Vue.prototype.$dateDayFormat = "YYYY-MM-DD";
        Vue.prototype.$dateFormat = "YYYY-MM-DD 18:00";
        Vue.prototype.$date23Format = "YYYY-MM-DD 23:59:59";
        Vue.prototype.$datejdTime = "YYYY-MM-DD HH:mm:00";
        Vue.prototype.$mmddhhmm = "MM-DD HH:mm";
        // 获取当前时间
        Vue.prototype.$getTime = function () {
        var date = new Date(),
        year = date.getFullYear(),
        month = date.getMonth() + 1,
        day = date.getDate(),
        hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(),
        minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(),
        second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        month >= 1 && month <= 9 ? (month = "0" + month) : "";
        day >= 0 && day <= 9 ? (day = "0" + day) : "";
            var timer = year + month + day + hour + minute + second+'00';
        // var timer = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
        return timer;
        }
        // 获取当前日期（yyyyMMddHHmmss）
            Vue.prototype.$getFormatTime = function() {
                var date = new Date(),
                    year = date.getFullYear(),
                    month = date.getMonth() + 1,
                    day = date.getDate(),
                    hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(),
                    minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(),
                    second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
                month >= 1 && month <= 9 ? (month = "0" + month) : "";
                day >= 0 && day <= 9 ? (day = "0" + day) : "";
                var timer = year + month + day + hour + minute + second;
                // var timer = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
                return timer;
            }
        // 2601(安卓客户端),2604(IOS客户端),2607(管控),2608(网站),2609(微信小程序)
            Vue.prototype.$MD5Param = function(param) {
                param.sType = "2608";
                param.time = this.$getFormatTime();
                var arr = [];
                for (var key in param) {
                    arr.push(key);
                }
                arr = arr.sort();
                var newData = [];
                for (var i in arr) {
                    var itemKey = arr[i];
                    newData.push(param[itemKey]);
                }
                var tempString = newData.join("");
                var sign = md5('web666pt365' + tempString);
                param.sign = sign;
                return param;
            }
        Vue.prototype.$postAjax = function (url, param, callback) {
                var paramResult = this.$MD5Param(param);
        console.log(paramResult, '====================paramResult')
        this.postAxios(url, {...paramResult,jsSessionId:localStorage.sessionid}).then((res) => {
           
            if (res.errorcode === 100) {
            console.log('%c [ post 正常 入参 ]'+url, 'font-size:13px; background:green; color:#fff;', param)
            console.log('%c [ post 正常 回参 ]'+url, 'font-size:13px; background:green; color:#fff;', res)
            callback(res);
            } else {
            console.log('%c [ post 错误 入参 ]'+url, 'font-size:13px; background:red; color:#fff;', param)
            console.log('%c [ post 错误 回参 ]'+url, 'font-size:13px; background:red; color:#fff;', res)
            callback(res);
            }
        }).catch((err) => {
            console.log('%c [ post 异常 ]', 'font-size:13px; background:yellow; color:#000;', err)
            // this.$errorCallback(err.response.status, err.message);
        })
        }
        Vue.prototype.$getAjax = function (url, param, callback) {
        var paramResult = this.$MD5Param(param);
        console.log(paramResult, '----paramResult');
        console.log(url, '=====================url');
        console.log(localStorage.sessionid,'==================localStorage.sessionid');
        this.getAxios(url, { ...paramResult, jsSessionId: localStorage.sessionid }).then((res) => {
    console.log(res, '----------------------------------------------------------')

            if (res.errorcode === 100) {
            console.log('%c [ get 成功 入参 ]', 'font-size:13px; background:green; color:#fff;', param)
            console.log('%c [ get 成功 回参 ]', 'font-size:13px; background:green; color:#fff;', res)
            // this.$message.success('操作成功!');
            callback(res);
            } else {
            console.log('%c [ get 错误 入参 ]', 'font-size:13px; background:red; color:#fff;', param)
            console.log('%c [ get 错误 回参 ]', 'font-size:13px; background:red; color:#fff;', res)
            callback(res);

            // this.$error({
            //   title: "提示",
            //   content: res.message,
            // });
            }
        }).catch((err) => {
            console.log('%c [ get 异常 ]', 'font-size:13px; background:yellow; color:#000;', err);
            globalBus.$emit('isLogin', false);
            // this.$errorCallback(err.response.status, err.message);
        })
        }
        Vue.prototype.$postAjaxWithCallback = function (url, param, callback) {
        this.postAxios(url, param).then((res) => {
            if (res.errorcode === 100) {
            callback(res);
            } else {
            this.$Message.error(res.message);
            }
        }).catch((err) => {
            this.$errorCallback(err.response.status, err.message);
        })
        }
        Vue.prototype.$getAjaxWithCallback = function (url, param, callback) {
        this.getAxios(url, param).then((res) => {
            if (res.errorcode === 100) {
            callback(res);
            } else {
            this.$Message.error(res.message);
            }
        }).catch((err) => {
            this.$errorCallback(err.response.status, err.message);
        })
        }
        //系统错误特殊处理
        Vue.prototype.$errorCallback = function (code, errMessage) {
        if (code === 403) {
            this.$error({
            title: "提示",
            content: '禁止访问',
            });
        } else if (code === 401) {
            this.$error({
            title: "提示",
            content: '系统未认证',
            });
        } else if (code === 404) {
            this.$error({
            title: "提示",
            content: '接口信息获取失败',
            });
        } else if (code === 400) {
            this.$error({
            title: "提示",
            content: '操作失败',
            });
        } else if (code === 500) {
            this.$error({
            title: "提示",
            content: '操作失败',
            });
        } else {
            this.$error({
            title: "提示",
            content: errMessage,
            });
        }
        }
    }
}
